import {
  RESOURCE_CHANGES_REPOSITORY,
  IResourceChangesRepository,
  LOAD_RESOURCE_CHANGES_USE_CASE,
  LoadResourceChangesUseCase,
  SAVE_RESOURCE_CHANGES_USE_CASE,
  SaveResourceChangesUseCase,
  REMOVE_RESOURCE_CHANGE_USE_CASE,
  RemoveResourceChangeUseCase,
  REMOVE_ALL_RESOURCE_CHANGES_USE_CASE,
  RemoveAllResourceChangesUseCase,
} from '@module/ai';

export const aiResourceChangesUseCaseProviders: any[] = [
  {
    provide: LOAD_RESOURCE_CHANGES_USE_CASE,
    useFactory: (repo: IResourceChangesRepository) => new LoadResourceChangesUseCase(repo),
    inject: [RESOURCE_CHANGES_REPOSITORY],
  },
  {
    provide: SAVE_RESOURCE_CHANGES_USE_CASE,
    useFactory: (repo: IResourceChangesRepository) => new SaveResourceChangesUseCase(repo),
    inject: [RESOURCE_CHANGES_REPOSITORY],
  },
  {
    provide: REMOVE_RESOURCE_CHANGE_USE_CASE,
    useFactory: (repo: IResourceChangesRepository) => new RemoveResourceChangeUseCase(repo),
    inject: [RESOURCE_CHANGES_REPOSITORY],
  },
  {
    provide: REMOVE_ALL_RESOURCE_CHANGES_USE_CASE,
    useFactory: (repo: IResourceChangesRepository) => new RemoveAllResourceChangesUseCase(repo),
    inject: [RESOURCE_CHANGES_REPOSITORY],
  },
];
